export default __webpack_public_path__ + "static/media/bg_vc.37a091c6.jpg";